export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:4000/api/v1',
  socketUrl: import.meta.env.VITE_SOCKET_URL ?? 'http://localhost:4000',
  livekitUrl: import.meta.env.VITE_LIVEKIT_URL ?? 'ws://localhost:7880',
  appName: import.meta.env.VITE_APP_NAME ?? 'ConnectMeet',
} as const;
